import { render, staticRenderFns } from "./addWorkList.vue?vue&type=template&id=67e4f474&scoped=true"
import script from "./addWorkList.vue?vue&type=script&lang=js"
export * from "./addWorkList.vue?vue&type=script&lang=js"
import style0 from "./addWorkList.vue?vue&type=style&index=0&id=67e4f474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4f474",
  null
  
)

export default component.exports